@if(!isForgotPasswordSuccessfull){
<div id="login" class="inner-scroll login-main">
  <div class="absolute inset-0 top-0 left-0">
    <img src="../images/new/dark-material-bg.jpg" class="h-full object-cover" />
  </div>

  <div id="login-form-wrapper" class="login-wrapper bg-white">

    <div id="login-form" class="p-relative w-full shadow-none"
      [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
      <div class="w-40 m-auto">
        <img src="../images/new/biz-logo.png" alt="Logo">
      </div>
      @if(apiResponseErrorMessage!=null){
      <div class="message-box error mb-10">
        <span class="custom-span-pre">{{apiResponseErrorMessage}}</span>
      </div>
      }

      <div>
        <div class="mt-5 auth-title">
          Forgot Password
        </div>
        <form class="mt-8" name="frmForgotPassword" [formGroup]="frmForgotPassword" (submit)="forgotPassword()"
          novalidate>
          <mat-form-field>
            <input matInput placeholder="Email" formControlName="email" required>
            @if(frmForgotPassword.get('email').hasError('required')){
            <mat-error>
              Email is required
            </mat-error>
            }
            @if(!frmForgotPassword.get('email').hasError('required') &&
            frmForgotPassword.get('email').hasError('invalidEmailAddress')){
            <mat-error>
              Please enter a valid email address
            </mat-error>
            }
          </mat-form-field>

          <button type="submit" mat-raised-button
            class="fuse-mat-button-large submit-button bg-primary text-white w-full" aria-label="LOGIN"
            [disabled]="!frmForgotPassword.valid||isSubmitBtnDisabled">
            Forgot Password
          </button>
          <div class="message text-center">
            <a class="link text-primary-500 hover:underline" [routerLink]="'/auth/login'">Go back to login page</a>
          </div>
        </form>
      </div>

    </div>
  </div>
</div>
}

@if(isForgotPasswordSuccessfull){
<div id="mail-confirm" fxLayout="column">
  <div id="mail-confirm-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
    <div id="mail-confirm-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
      <div class="logo">
        <mat-icon class="mat-accent s-96">email</mat-icon>
      </div>
      <div class="title">Forgot Password</div>
      <div class="subtitle">
        <p>
          A reset link has been sent to <b>{{myEmail}}</b>.
        </p>
        <p>
          Check your inbox and reset your password.
        </p>
      </div>
      <div class="message">
        <a class="link" [routerLink]="'/auth/login'">Go back to login page</a>
      </div>
    </div>
  </div>
</div>
}